module.exports = __webpack_public_path__ + "img/calendar.6f6643f0.svg";